import { Button } from "@/pages/newHome/ui/button";
import image03 from "@/assets/newHome/image-3.png";
import img1 from "@/assets/newHome/hero-image@2x.webp";
// import ScheduleDemo from "@/features/onboarding/login/Schedule-demo";
import {  useSelector } from "react-redux";
import {  RootState } from "@/store";
import { useNavigate } from "react-router-dom";

export const HeroByAnima = (): JSX.Element => {
  const user = useSelector(
    (state: RootState) => state.rootReducer.userReducer.user
  );
    const navigate = useNavigate();

  console.log(user,"line 13")

  return (
    <section className="min-h-[55vh] md:min-h-0 xl:min-h-[95vh] flex flex-col justify-start lg:justify-center relative xl:w-full w-full  px-4 sm:px-6 md:px-12 lg:px-20 bg-[linear-gradient(360deg,_#EEFFF2_0%,_#FFFFFF_100%)] overflow-hidden pointer-events-auto">
      <div className="min-[615px]:mt-[2rem] sm:mt-[2rem] md:mt-[3rem] lg:mt-[2rem] lg:w-full xl:w-full xl:mt-[-2rem] xl:mx-auto  2xl:w-[95%] 2xl:mx-auto 4xl:w-[80%] 4xl:mx-auto  2xl:mt-[-6rem]">
        {/* Background Image */}
        <div className="absolute left-0 w-full bottom-0 mt-[50px] lg:mt-[100px] opacity-30 z-0">
          <img
            className="w-full h-[200px] object-cover sm:h-auto  lg:object-contain pointer-events-none"
            alt="Construction project showcase"
            src={image03}
          />
        </div>

        {/* Content Wrapper */}
        <div className="relative z-10 flex flex-col md:flex-row xl:items-center justify-between 2xl:justify-normal w-full gap-20 xl:gap-15 2xl:gap-[5.5rem] py-32 md:py-12 ">
          {/* Left Content */}
          <div className="w-full md:w-1/2 max-w-3xl text-center sm:text-left lg:mt-[2rem] sm:mt-[1rem]">
            <div className="flex w-[80%] mx-auto sm:mx-0 md:w-[105%] xl:w-full 2xl:w-[107%] items-center justify-center md:gap-2.5">
              <h1 className="font-bold text-charcoal text-[44px] sm:text-[28px] md:text-[40px] xl:text-[52px] 2xl:text-[70px] leading-[52px] md:leading-[52px] xl:leading-[65px] 2xl:leading-[80px]">
                The All-In-One Construction Sales Platform
              </h1>
            </div>
            

            <div className="flex items-center justify-center mt-2 gap-2.5 w-[80%] mx-auto sm:mx-0 md:w-full lg:w-[102%] xl:w-[99%] 2xl:w-[80%]">
              <p className="font-normal text-charcoal text-lg md:text-[20px] lg:text-2xl lg:leading-[38.4px] 2xl:text-2xl leading-[25.2px] sm:leading-[1.6] md:leading-[28px] xl:leading-[38.4px]">
                We help construction companies build a world-class sales process
              </p>
            </div>

            <div className="mt-6 flex justify-center sm:justify-start">
              {/* <ScheduleDemo>
                <Button className="sm:w-40 h-[50px] rounded-[40px] bg-primary hover:bg-[#239e41] shadow-none text-[16px] md:text-lg sm:text-xl font-medium text-white">
                  Get Started
                </Button>
              </ScheduleDemo> */}
              <Button
  onClick={(e) => {
    if (user) {
      e.preventDefault();
      navigate("/dashboard/explore_leads");
    } else {
      // window.open("https://buildmapper.typeform.com/to/oVrzJex7", "_blank");
      //  window.open(`${window.location.origin}/newOnboarding`, "_self");
        navigate("auth/signup")
    }
  }}
  className="sm:w-40 h-[50px] rounded-[40px] bg-primary hover:bg-[#239e41] shadow-none text-[16px] md:text-lg sm:text-xl font-medium text-white"
>
  Get Started
</Button>

            </div>
          </div>

          {/* Right Image */}
          <div className="hidden min-[768px]:block w-full md:w-1/2 max-w-lg 2xl:max-w-4xl">
            <img
              className="w-full h-auto object-contain"
              alt="Construction sales platform interface"
              src={img1}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
